
const FacebookIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <rect width="18" height="18" fill="white" />
      <path d="M16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 12.7434 4.24263 15.8462 7.82812 16.4089V11.168H5.92383V9H7.82812V7.34766C7.82812 5.46797 8.94785 4.42969 10.661 4.42969C11.4813 4.42969 12.3398 4.57617 12.3398 4.57617V6.42188H11.3941C10.4625 6.42188 10.1719 7.00005 10.1719 7.59375V9H12.252L11.9194 11.168H10.1719V16.4089C13.7574 15.8462 16.5 12.7434 16.5 9Z" fill="#1877F2" />
      <path d="M11.9194 11.168L12.252 9H10.1719V7.59375C10.1719 7.00005 10.4625 6.42188 11.3941 6.42188H12.3398V4.57617C12.3398 4.57617 11.4813 4.42969 10.661 4.42969C8.94785 4.42969 7.82812 5.46797 7.82812 7.34766V9H5.92383V11.168H7.82812V16.4089C8.60465 16.5304 9.39535 16.5304 10.1719 16.4089V11.168H11.9194Z" fill="white" />
    </svg>
  )
}

export default FacebookIcon